import { render } from "./celltemplate.vue?vue&type=template&id=1266cdf4"
import script from "./celltemplate.vue?vue&type=script&lang=js"
export * from "./celltemplate.vue?vue&type=script&lang=js"

import "./celltemplate.vue?vue&type=style&index=0&id=1266cdf4&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__